import React from 'react'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Customcard from './Customcard';
import "../About/About.css"
import Logowordpress from "../../images/Content/wordpress.png"
import Logohtml from "../../images/Content/html-5.png"
import Logocss from "../../images/Content/css-3.png"
import Logojs from "../../images/Content/js.png"
import Logoreact from "../../images/Content/biblioteca.png"
import Button from 'react-bootstrap/Button';
import tecnologiasI  from "../../images/Content/tecnologias.png"
const Tecnologias = () => {
  return (
    <>
    <Container>
    <div className='div-tecnologias' data-aos="flip-right">
    <h1 className='titulo-servicio'><img className='icono-titulo' src={tecnologiasI} />Tecnologias<img className='icono-titulo' src={tecnologiasI} /></h1>
            <br></br>
            <p className='parrafo-servicio' style={ { color:"White",}} >Estas son las tecnologias principales que utilizamos para crear tu solucion digital!!</p>
            <Row className='row-esp'>
            
            <Customcard title={"Wordpress"} text={"Desarrollo en wordpress"} img={Logowordpress} moreInfo={"Plataforma CMS popular para crear y gestionar sitios web. Ofrece una interfaz intuitiva, amplia personalización a través de temas y plugins."} />
            <Customcard title={"Html"} text={"Desarrollo en wordpress"} img={Logohtml} moreInfo={"Lenguaje de marcado estándar para la creación y estructuración de contenido en páginas web."}/>
            <Customcard title={"Css"} text={"Desarrollo en wordpress"} img={Logocss} moreInfo={"Lenguaje de estilo que define la presentación y el diseño visual de las páginas web."}/>
            <Customcard title={"Javascript"} text={"Desarrollo en wordpress"} img={Logojs} moreInfo={"Lenguaje de programación utilizado para agregar interactividad y funcionalidad dinámica a las páginas web."}/>
            <Customcard title={"React"} text={"Desarrollo en wordpress"} img={Logoreact} moreInfo={" Biblioteca de JavaScript para construir interfaces de usuario interactivas. Sirve para crear aplicaciones web eficientes y escalables."}/>
            </Row>
            </div>
    </Container>
  </>
  ) 
}


export default Tecnologias